import styled from "styled-components";

interface PaddingProps {
    paddingTop?: string; 
    paddingLeft?: string; 
    paddingRight?: string; 
    paddingBottom?: string; 
}

interface TextProps {
  color?: string;
  fontWeight?: string | number;
  fontSize?: string;
  lineHeight?: string;
  textAlign?: string;
  textTransform?: string;
  margin?: string;
  cursor?: string;
  textDecoration?: string;
}

export const StyledInputPrefix = styled.div`
    .Polaris-TextField__Prefix {
        order: 2;
    }

    .Polaris-TextField__Input {
        order: 1;
        padding: 0 12px;
    }

    .Polaris-TextField__Spinner {
        order: 3
    }
`

export const StyledPadding = styled.div<PaddingProps>`
    padding-top: ${(props) => props.paddingTop || 'initial'};
    padding-right: ${(props) => props.paddingRight || 'initial'};
    padding-bottom: ${(props) => props.paddingBottom || 'initial'};
    padding-left: ${(props) => props.paddingLeft || 'initial'};
`

export const StyledText = styled.span<TextProps>`
  color: ${(props) => props.color || 'inherit'};
  font-weight: ${(props) => props.fontWeight || 'normal'};
  font-size: ${(props) => props.fontSize || 'inherit'};
  line-height: ${(props) => props.lineHeight || 'normal'};
  text-align: ${(props) => props.textAlign || 'inherit'};
  text-transform: ${(props) => props.textTransform || 'none'};
  margin: ${(props) => props.margin || '0'};
  cursor: ${(props) => props.cursor || 'inherit'};
  text-decoration: ${(props) => props.textDecoration || 'none'};
`;
